<template>
	<div class="box">
		
		<el-row :gutter="20">
			<el-col :span="4"  class="menu">
				<div @click="goyf">
					<el-card shadow="hover">
						<div class="menu-item">
							访员配置 <i class="menu-icon el-icon-arrow-right"></i>
						</div>
					</el-card>
				</div>
			</el-col>
			<el-col :span="4" class="menu">
				<div  @click="goyb">
					<el-card shadow="hover">
						<div class="menu-item">
							样本配置 <i class="menu-icon el-icon-arrow-right"></i>
						</div>
					</el-card>
				</div>
			</el-col>
			<el-col :span="4" class="menu">
				<div  @click="goxszd">
					<el-card shadow="hover">
						<div class="menu-item">
							显示字段设置 <i class="menu-icon el-icon-arrow-right"></i>
						</div>
					</el-card>
				</div>
			</el-col>
			<el-col :span="4" class="menu" v-for="item in setList" :key="item.id">
				<div  @click="setStatistics(item.path)">
					<el-card shadow="hover">
						<div class="menu-item">
							{{ item.title }} <i class="menu-icon el-icon-arrow-right"></i>
						</div>
					</el-card>
				</div>
			</el-col>
			<el-col :span="4" class="menu">
					<el-card shadow="hover">
						<div class="menu-item">
							<el-popover placement="top-start" trigger="hover">
								<img src="../../assets/app.png" alt="">
								<span type="text" slot="reference">Android二维码</span><i class="menu-icon el-icon-arrow-right"></i>
							</el-popover>
						</div>
					</el-card>
			</el-col>
		</el-row>
		<!-- <div class="BoxEcharts">
			<div class="ybStatistics">
				<div class="topTitle">
					<div class="title">样本统计</div>
					<div>
						<el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期"
							v-model="timeParams.beginTime" style="width: 150px;"></el-date-picker>
						<el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期"
							v-model="timeParams.endTime" style="width: 150px;"></el-date-picker>
						<el-button @click="cx">查询</el-button>
					</div>
					<div class="unit">单位(个)</div>
				</div>
				<div class="echart" ref="Lmain"></div>
			</div>
			<div class="fyNum">
				<div class="topTitle">
					<div class="title">访员人数</div>
				</div>

				<div class="echart" ref="Rmain"></div>
			</div>
		</div> -->
		
		<div class="BoxEcharts">
			<el-row :gutter="20">
				<el-col :span="12">
					<el-card shadow="never">
									<div class="ybStatistics">
							<div class="topTitle">
								<div class="title">样本统计</div>
								<div>
									<el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期"
										v-model="timeParams.beginTime" style="width: 150px;margin-right: 10px;"></el-date-picker>
									<el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期"
										v-model="timeParams.endTime" style="width: 150px;margin-right: 10px;"></el-date-picker>
									<el-button type="primary" @click="cx">查询</el-button>
								</div>
								<div class="unit">单位(个)</div>
							</div>
							<div class="echart" ref="Lmain"></div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="12">
					<el-card shadow="never">
						<div class="fyNum">
							<div class="topTitle">
								<div class="title">访员人数</div>
							</div>

							<div class="echart" ref="Rmain"></div>
						</div>
					</el-card>
				</el-col>
			</el-row>
		</div>
		<!-- <div class="addressBar">下载地址：<span></span>

			<el-popover placement="top-start" width="200" trigger="hover">
				<img src="../../assets/app.png" alt="">
				<el-button style="color:#ffffff ;font-size: 24px;" type="text" slot="reference">Android二维码</el-button>
			</el-popover>
		</div> -->
		<router-view ></router-view>
	</div>
</template>

<script>
	import echarts from 'echarts';
	export default {
		data() {
			return {
				timeParams: {
					beginTime: '',
					endTime: ''
				},
				surveyId: '', //问卷id
				value: '',
				setList: [{
						id: '1',
						title: '设置',
						path: 'setMfSample'
					},
					{
						id: '2',
						title: '配额',
						path: 'addQuota'
					},
					{
						id: '3',
						title: '样本指派',
						path: 'newSampleAssignment'
					},
					{
						id: '4',
						title: '答卷审核',
						path: 'sampleReview'
					},

				]
			};
		},
		created() {
			this.surveyId = sessionStorage.getItem('wid');
			this.leftEcharts();
			this.rightEcharts();
		},
		methods: {
			cx() {
				this.leftEcharts();
			},
			setStatistics(path) {
				let id = sessionStorage.getItem('wid');
				this.$router.push({
					path: path,
					query: {
						id: id,
						source: 'mf'
					}
				});
			},
			goxszd() {
				let id = sessionStorage.getItem('wid');
				this.$router.push({
					path: '/wjmanage/wjpub/mfdisplayField',
					query: {
						id: id,
						source: 'mf'
					}
				});
			},
			goyb() {
				let id = sessionStorage.getItem('wid');
				this.$router.push({
					path: '/wjmanage/wjpub/sample',
					query: {
						id: id,
						source: 'mf'
					}
				});
			},
			goyf() {
				let id = sessionStorage.getItem('wid');
				this.$router.push({
					path: '/wjmanage/wjpub/interviewer',
					query: {
						id: id,
						source: 'mf'
					}
				});
			},
			leftEcharts() {
				let that = this;
				let data = [];
				let params = {
					that: this,
					url: `${this.$config.service.queryWJSampleStatisticsChart}`,
					method: 'POST',
					data: {
						source: 'mf',
						surveyId: that.surveyId,
						beginTime: that.timeParams.beginTime,
						endExamTime: that.timeParams.endTime
					},
					cb(res) {
						console.log('leftEcharts', res.resultBody);
						if (res.code == 0) {
							data = res.resultBody;
							that.leftEchartsTwo(data);
						} else {
							that.$message.error(res.message);
						}
					}
				};
				this.$util.request(params);
			},
			leftEchartsTwo(data) {
				let xAxisData = [];
				let seriesData = [];
				data.forEach(item => {
					xAxisData.push(item.answerName);
					seriesData.push(item.number);
				});
				// console.log(xAxisData, seriesData);
				setTimeout(() => {
					let getchart = echarts.init(this.$refs.Lmain);
					// console.log(xAxisData, seriesData);
					let option = {
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow'
							}
						},
						xAxis: {
							type: 'category',
							data: xAxisData
						},
						yAxis: {
							type: 'value'
						},
						series: [{
							data: seriesData,
							type: 'bar',
							barWidth: '20%'
						}],
						color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f',
							'#dadde2'
						]
					};
					getchart.clear();
					getchart.setOption(option);
					//随着屏幕大小调节图表
					window.addEventListener('resize', () => {
						getchart.resize();
					});
				}, 0);
			},
			rightEcharts() {
				let that = this;
				let data = {};
				let params = {
					that: this,
					url: `${this.$config.service.queryUserCount}`,
					method: 'POST',
					data: {
						source: 'mf',
						surveyId: that.surveyId
					},
					cb(res) {
						// console.log('rightEcharts', res.resultBody);
						if (res.code == 0) {
							data = res.resultBody[0];
							that.rightEchartsTwo(data);
						} else {
							that.$message.error(res.message);
						}
					}
				};
				this.$util.request(params);
			},
			rightEchartsTwo(data) {
				let xAxisData = ['访员总数', '在线'];
				let seriesData = [];
				seriesData[0] = data.total;
				seriesData[1] = data.onlineCount;
				setTimeout(() => {
					let getchart = echarts.init(this.$refs.Rmain);
					let option = {
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow'
							}
						},
						xAxis: {
							type: 'category',
							data: xAxisData
						},
						yAxis: {
							type: 'value'
						},
						series: [{
							data: seriesData,
							type: 'bar',
							barWidth: '20%'
						}],
						color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f',
							'#dadde2'
						]
					};

					getchart.clear();
					getchart.setOption(option);
					//随着屏幕大小调节图表
					window.addEventListener('resize', () => {
						getchart.resize();
					});
				}, 0);
			}
		}
	};
</script>

<style scoped lang="scss">
	.box{
		width: 1200px;
		margin: 0 auto;
		padding: 20px;
		box-sizing: border-box;
	}
	.menu{
		margin-bottom: 20px;
		cursor: pointer;
		.menu-item{
			display: flex;
			align-items: center;
    		justify-content: space-between;
		}
	}
	.Boxheader {
		height: 335px;
		max-width: 1000px;
		width: 100%;
		margin: 20px auto;
		background-color: #ffffff;

		.configuration {
			padding: 20px;
			display: flex;
			justify-content: space-between;

			.cGBtn {
				width: 256px;
				height: 90px;
				line-height: 90px;
				text-align: center;
				color: #ffffff;
				cursor: pointer;
				font-size: 26px;
			}

			.fyBtn {
				background-color: #22aab6;
			}

			.ybBtn {
				background-color: #8e549a;
			}

			.gjBtn {
				background-color: #51559a;
			}

			.iconBtn {
				line-height: 90px;
			}
		}

		.setBtn {
			padding: 20px;
			display: flex;
			flex-wrap: wrap;

			.eachBtn {
				width: 132px;
				height: 53px;
				border-radius: 26px;
				background-color: #8dd0fd;
				color: #ffffff;
				line-height: 53px;
				text-align: center;
				margin-right: 20px;
				margin-top: 20px;
				cursor: pointer;
			}
		}
	}

	.BoxEcharts {
		box-sizing: border-box;
		background-color: #ffffff;
		.ybStatistics {
			.topTitle {
				display: flex;
				justify-content: space-between;
				height: 40px;
				line-height: 40px;
				.title {
					font-family: SourceHanSansSC;
					font-weight: 400;
					font-size: 16px;
					color: rgba(16, 16, 16, 0.8);
					font-style: normal;
					letter-spacing: 0px;
					line-height: 40px;
					text-decoration: none;
				}

				.unit {
					right: 0px;
					top: 60px;
					font-size: 12px;
					color: rgba(16, 16, 16, 0.6);
					font-style: normal;
					letter-spacing: 0px;
					line-height: 20px;
					text-decoration: none;
				}
			}

			.echart {
				height: 400px;
			}
		}

		.fyNum {
			.topTitle {
				display: flex;
				justify-content: space-between;
				height: 40px;
				line-height: 40px;

				.title {
					font-family: SourceHanSansSC;
					font-weight: 400;
					font-size: 16px;
					color: rgba(16, 16, 16, 0.8);
					font-style: normal;
					letter-spacing: 0px;
					line-height: 40px;
					text-decoration: none;
				}
			}

			.echart {
				height: 400px;
			}
		}
	}

	.addressBar {
		max-width: 1000px;
		width: calc(100% - 30px);
		margin: 20px auto;
		height: 60px;
		line-height: 60px;
		color: #ffffff;
		background-color: #8dd0fd;
		font-size: 24px;
		border-radius: 30px;
		padding-left: 30px;
		margin-top: 20px;
		margin-bottom: 20px;
	}
</style>
